import { EVENT_KEYNAMES as e, HTML_ELEMENT_TYPE as t } from "../../common/constants/index.js";
import { disableRootScrolling as n, enableRootScrolling as r, getUniqueString as i, hasSlotContent as a, returnFirstEl as o } from "../../common/utils/index.js";
import { t as s } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import c from "../../common/mixins/modal.js";
import { NOTICE_KINDS as l } from "../notice/notice-constants.js";
import { DialtoneLocalization as u } from "../../localization/index.js";
import d from "../button/button.js";
import f from "../../shared/sr_only_close_button.js";
import p from "../lazy-show/lazy-show.js";
import { MODAL_BANNER_KINDS as m, MODAL_KIND_MODIFIERS as h, MODAL_SIZE_MODIFIERS as g } from "./modal-constants.js";
import { Teleport as _, Transition as v, createBlock as y, createCommentVNode as b, createElementBlock as x, createElementVNode as S, createTextVNode as C, createVNode as w, mergeProps as T, normalizeClass as E, openBlock as D, renderSlot as O, resolveComponent as k, toDisplayString as A, toHandlers as j, vShow as M, withCtx as N, withDirectives as P } from "vue";
import { DtIconClose as F } from "@dialpad/dialtone-icons/vue3";
//#region components/modal/modal.vue
var I = {
	compatConfig: { MODE: 3 },
	name: "DtModal",
	components: {
		DtLazyShow: p,
		DtButton: d,
		DtIconClose: F,
		SrOnlyCloseButton: f
	},
	mixins: [c],
	props: {
		copy: {
			type: String,
			default: ""
		},
		describedById: {
			type: String,
			default: ""
		},
		labelledById: {
			type: String,
			default: function() {
				return i();
			}
		},
		show: {
			type: Boolean,
			default: !1
		},
		title: {
			type: String,
			default: ""
		},
		bannerTitle: {
			type: String,
			default: ""
		},
		kind: {
			type: String,
			default: "default",
			validator: (e) => Object.keys(h).includes(e)
		},
		size: {
			type: String,
			default: "default",
			validator: (e) => Object.keys(g).includes(e)
		},
		modalClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		dialogClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		contentClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		bannerKind: {
			type: String,
			default: "warning",
			validate(e) {
				return l.includes(e);
			}
		},
		bannerClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		hideClose: {
			type: Boolean,
			default: !1
		},
		closeOnClick: {
			type: Boolean,
			default: !0
		},
		fixedHeaderFooter: {
			type: Boolean,
			default: !0
		},
		initialFocusElement: {
			type: [String, t],
			default: "first",
			validator: (e) => e === "first" || e instanceof HTMLElement || e.startsWith("#")
		},
		appendTo: {
			type: String,
			default: void 0
		}
	},
	emits: [
		"click",
		"keydown",
		"update:show"
	],
	data() {
		return {
			MODAL_KIND_MODIFIERS: h,
			MODAL_SIZE_MODIFIERS: g,
			MODAL_BANNER_KINDS: m,
			EVENT_KEYNAMES: e,
			hasSlotContent: a,
			i18n: new u()
		};
	},
	computed: {
		modalListeners() {
			return {
				mousedown: (e) => {
					this._mousedownOnBackdrop = e.target === e.currentTarget;
				},
				click: (e) => {
					this.closeOnClick && e.target === e.currentTarget && this._mousedownOnBackdrop && this.close(), this.$emit("click", e);
				},
				keydown: (t) => {
					switch (t.code) {
						case e.esc:
						case e.escape:
							this.close();
							break;
						case e.tab:
							this.trapFocus(t);
							break;
					}
					this.$emit("keydown", t);
				},
				"after-enter": async () => {
					this.$emit("update:show", !0), await this.setFocusAfterTransition();
				},
				focusin: (e) => {
					let t = this.$refs.modalRoot?.$el || this.$el;
					this.show && t && !t.contains(e.target) && (e.preventDefault(), this.focusFirstElement(t));
				}
			};
		},
		open() {
			return `${!this.show}`;
		},
		hasFooterSlot() {
			return !!this.$slots.footer;
		},
		bannerKindClass() {
			return m[this.bannerKind];
		},
		closeButtonTitle() {
			return this.i18n.$t("DIALTONE_CLOSE_BUTTON");
		}
	},
	watch: { show: { handler(e) {
		e ? (this.previousActiveElement = document.activeElement, n(o(this.$refs.modalRoot?.$el || this.$el).getRootNode().host), document.addEventListener("keydown", this._trapFocusGlobalBound)) : (r(o(this.$refs.modalRoot?.$el || this.$el).getRootNode().host), this.previousActiveElement?.focus(), this.previousActiveElement = null, document.removeEventListener("keydown", this._trapFocusGlobalBound));
	} } },
	created() {
		this._trapFocusGlobalBound = (e) => this._trapFocusGlobal(e), this._mousedownOnBackdrop = !1;
	},
	mounted() {
		this.show && document.addEventListener("keydown", this._trapFocusGlobalBound);
	},
	beforeUnmount() {
		document.removeEventListener("keydown", this._trapFocusGlobalBound);
	},
	methods: {
		close() {
			this.$emit("update:show", !1);
		},
		async setFocusAfterTransition() {
			let e = this.$refs.modalRoot?.$el || this.$el;
			this.initialFocusElement === "first" ? await this.focusFirstElement(e) : this.initialFocusElement.startsWith("#") ? await this.focusElementById(this.initialFocusElement) : this.initialFocusElement instanceof HTMLElement && this.initialFocusElement.focus();
		},
		trapFocus(e) {
			if (this.show) {
				let t = this.$refs.modalRoot?.$el || this.$el;
				this.focusTrappedTabPress(e, t);
			}
		},
		_trapFocusGlobal(t) {
			if (!this.show || t.code !== e.tab) return;
			let n = this.$refs.modalRoot?.$el || this.$el;
			n && !n.contains(document.activeElement) && (t.preventDefault(), this.focusFirstElement(n));
		}
	}
}, L = ["aria-describedby", "aria-labelledby"], R = ["id"], z = ["id"], B = {
	key: 4,
	class: "d-modal__footer"
};
function V(e, t, n, r, i, a) {
	let o = k("sr-only-close-button"), s = k("dt-icon-close"), c = k("dt-button"), l = k("dt-lazy-show");
	return D(), y(_, {
		disabled: !n.appendTo,
		to: n.appendTo
	}, [w(l, T({
		ref: "modalRoot",
		transition: "d-zoom",
		show: n.show,
		class: [
			"d-modal",
			i.MODAL_KIND_MODIFIERS[n.kind],
			i.MODAL_SIZE_MODIFIERS[n.size],
			n.modalClass
		],
		"data-qa": "dt-modal",
		"aria-hidden": a.open
	}, j(a.modalListeners)), {
		default: N(() => [n.show && (i.hasSlotContent(e.$slots.banner) || n.bannerTitle) ? (D(), x("div", {
			key: 0,
			"data-qa": "dt-modal-banner",
			class: E([
				"d-modal__banner",
				n.bannerClass,
				a.bannerKindClass
			])
		}, [O(e.$slots, "banner", {}, () => [C(A(n.bannerTitle), 1)])], 2)) : b("", !0), w(v, {
			appear: "",
			name: "d-modal__dialog"
		}, {
			default: N(() => [P(S("div", {
				class: E([
					"d-modal__dialog",
					{ "d-modal__dialog--scrollable": n.fixedHeaderFooter },
					n.dialogClass
				]),
				role: "dialog",
				"aria-modal": "true",
				"aria-describedby": n.describedById,
				"aria-labelledby": n.labelledById
			}, [
				i.hasSlotContent(e.$slots.header) ? (D(), x("div", {
					key: 0,
					id: n.labelledById,
					class: "d-modal__header",
					"data-qa": "dt-modal-title"
				}, [O(e.$slots, "header")], 8, R)) : (D(), x("h2", {
					key: 1,
					id: n.labelledById,
					class: "d-modal__header",
					"data-qa": "dt-modal-title"
				}, A(n.title), 9, z)),
				i.hasSlotContent(e.$slots.default) ? (D(), x("div", {
					key: 2,
					class: E(["d-modal__content", n.contentClass]),
					"data-qa": "dt-modal-copy"
				}, [O(e.$slots, "default")], 2)) : (D(), x("p", {
					key: 3,
					class: E(["d-modal__content", n.contentClass]),
					"data-qa": "dt-modal-copy"
				}, A(n.copy), 3)),
				a.hasFooterSlot ? (D(), x("footer", B, [O(e.$slots, "footer")])) : b("", !0),
				n.hideClose ? (D(), y(o, {
					key: 5,
					onClose: a.close
				}, null, 8, ["onClose"])) : (D(), y(c, {
					key: 6,
					class: "d-modal__close",
					"data-qa": "dt-modal-close-button",
					size: "md",
					kind: "muted",
					importance: "clear",
					"aria-label": a.closeButtonTitle,
					title: a.closeButtonTitle,
					onClick: a.close
				}, {
					icon: N(({ iconSize: e }) => [w(s, { size: e }, null, 8, ["size"])]),
					_: 1
				}, 8, [
					"aria-label",
					"title",
					"onClick"
				]))
			], 10, L), [[M, n.show]])]),
			_: 3
		})]),
		_: 3
	}, 16, [
		"show",
		"class",
		"aria-hidden"
	])], 8, ["disabled", "to"]);
}
var H = /* @__PURE__ */ s(I, [["render", V]]);
//#endregion
export { H as default };

//# sourceMappingURL=modal.js.map